import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Popover(theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          // commonSelect menu paper
          // '&:has(.MuiPaper-root>.MuiList-root>.custom-select-item,.play-festival-item)':
          '&:has(.MuiPaper-root>.MuiList-root>.custom-select-item)': {
            width: '100%',
            maxWidth: '425px',
            right: 0,
            left: '50%',
            transform: 'translate(-50%,0)',
          },
        },
        paper: {
          boxShadow: theme.customShadows.z24,
          borderRadius: Number(theme.shape.borderRadius) * 1.5,
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.08)}`,
        },
      },
    },
  };
}
